<!-- <app-header-latest></app-header-latest> -->
<div class="exam-result-card" *ngIf="result">
  <ng-container *ngIf="result.isPass; else failBlock">
  <!-- <h3>🎓 Congratulations</h3> -->
  <h2 class="primary-color">{{ candidateName }}!</h2>
  <p class="subtitle" [innerHTML]="decodeHtml(result.resultSuccess)"></p>
</ng-container>

<ng-template #failBlock>
  <h3>{{ candidateName }}</h3>
  <p class="subtitle" [innerHTML]="decodeHtml(result.resultFail)"></p>
</ng-template>


  <!-- <p class="subtitle">You’ve completed the exam successfully.</p> -->
<div *ngIf="result.show_result === 'Y'">
  <!-- Total Marks -->
<div class="result-row" *ngIf="result.show_total_marks === 'Y'">
  <span>Total Marks</span>
  <span class="value">: {{ result.totalMarks }}</span>
</div>

<!-- Pass Marks -->
<div class="result-row" *ngIf="result.show_pass_marks === 'Y'">
  <span>Pass Marks</span>
  <span class="value">: {{ result.passMarks }}</span>
</div>

<!-- Percentage -->
<div class="result-row" *ngIf="result.show_percentage === 'Y'">
  <span>Percentage</span>
  <span class="value">: {{ result.percentage | number:'1.2-2' }}%</span>
</div>

<!-- Status -->
<div class="result-row status" *ngIf="result.show_results_status === 'Y'">
  <span>Status</span>
  <span class="value" [ngClass]="{'pass': result.isPass, 'fail': !result.isPass}">
    {{ result.isPass ? 'PASS' : 'FAIL' }}
  </span>
</div>
</div>
  <div  class="action-buttons">
  <button *ngIf="result.attemptsLeft > 0" class="btn btn-solid" (click)="retakeExam()">
     Retake Exam
  </button>
  <div *ngIf="result.check_result_status === 'Y'" class="verify-section">
  <button class="secondary-btn-round" (click)="verify.emit()">Verify Answers</button>
</div>
  <button class="secondary-btn-round" (click)="closeResult()">
    Close
  </button>
</div>

<!-- <div *ngIf="result.attemptsLeft === 0" class="action-buttons">
  <button class="btn btn-solid" (click)="closeResult()">
   Close
  </button>
</div> -->




</div>
<!-- <app-footer-more-info></app-footer-more-info> -->